import _ from 'lodash'

// For lost links report
export const paramNameMapper = {
  // GA4 names
  sessionSource: 'utm_source',
  sessionMedium: 'utm_medium',
  sessionCampaignName: 'utm_campaign',
  sessionManualTerm: 'utm_term',
  sessionManualAdContent: 'utm_content',
  sessionCampaignId: 'utm_id',
  marketingTactic: 'utm_marketing_tactic',
  creativeFormat: 'utm_creative_format',
  sourcePlatform: 'utm_source_platform',
  // UA names
  fullSource: 'utm_source',
  fullMedium: 'utm_medium',
  fullCampaign: 'utm_campaign',
  fullTerm: 'utm_term',
  fullContent: 'utm_content',
}

export const metricNameMapper = {
  sessions: 'Sessions',
  'Total not in uplifter': 'Other link sessions',
  'Total in uplifter': 'Uplifter link sessions',
}

export const fixedDates = [
  'thisMonth',
  'lastMonth',
  'thisQuarter',
  'lastQuarter',
  'thisYear',
]

export const setGranularityByDateRange = (
  startDate: Date,
  endDate: Date,
): Granularity => {
  const daysDifference = Math.round(
    (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24),
  )

  switch (true) {
    // 2 years
    case daysDifference > 730:
      return 'quarterly'
    // 3 months
    case daysDifference > 90:
      return 'monthly'
    // 1 month
    case daysDifference > 30:
      return 'weekly'
    default:
      return 'daily'
  }
}

// Used to reduce data window for performance report graph
// It removes all data columns (x-axis) that have no data from the start and end of the full data set
// Preserves all central data, including zero values
export const stripZeroValuesFromGraphData = (
  graphDateRange: string[],
  graphData: DashboardGraphData[],
): { graphDateRange: string[]; graphData: DashboardGraphData[] } => {
  const _graphDateRange: string[] = []
  const _graphData = graphData.reduce((acc, curr) => {
    acc.push({
      dimensionName: curr.dimensionName,
      dimensionValues: [],
    })

    return acc
  }, [] as DashboardGraphData[])

  let prevDatesHaveData = false

  // Forward pass - strip start dates
  graphDateRange.forEach((date, dateIndex) => {
    let dateHasData = false
    let dimIndex = 0

    while (dimIndex < graphData.length) {
      // 0 is falsy
      if (graphData[dimIndex].dimensionValues[dateIndex]) {
        dateHasData = true
        prevDatesHaveData = true
        break
      }

      dimIndex += 1
    }

    if (dateHasData || prevDatesHaveData) {
      _graphDateRange.push(date)
      graphData.forEach((dimensionData, dimensionIndex) => {
        _graphData[dimensionIndex].dimensionValues.push(
          dimensionData.dimensionValues[dateIndex],
        )
      })
    }
  })

  // Backwards pass - strip end dates
  let laterDatesHaveData = false
  let endIndex = _graphDateRange.length - 1

  while (!laterDatesHaveData && endIndex >= 0) {
    let dateHasData = false
    let dimIndex = 0

    while (dimIndex < _graphData.length) {
      // 0 is falsy
      if (_graphData[dimIndex].dimensionValues[endIndex]) {
        dateHasData = true
        laterDatesHaveData = true
        break
      }

      dimIndex += 1
    }

    if (!dateHasData) {
      _graphDateRange.pop()
      _graphData.forEach((dimensionData) => {
        dimensionData.dimensionValues.pop()
      })
    }

    endIndex -= 1
  }

  return {
    graphDateRange: _graphDateRange,
    graphData: _graphData,
  }
}
